var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex p-r-14", attrs: { slot: "header" }, slot: "header" },
    [
      _c("div", {
        staticClass: "h-32 w-6 m-t-6 bg-2E85F8",
        staticStyle: { transform: "rotate3d(1, 1, 1, 21deg)" },
      }),
      _c("div", {
        staticClass: "h-32 w-2 m-t-6 m-l-6 bg-2E85F8",
        staticStyle: { transform: "rotate3d(1, 1, 1, 21deg)" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }